<div class="panel-heading">
	<span>LOOP</span>
</div>

<div class="panel-body">
	<div class="form-group">
		<div class="row">
			<div class="col-sm-3"><label for=description>VARIABLE</label></div>
			<div class="col-sm-5">
				<input class="form-control" type="text" [(ngModel)]="node.propertyLabel" style="display: inline; width: 200px"  />
			</div>
		</div>
	</div>
</div>